/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AppCardListService,
  IAppCardListMethods,
  ILoadingMethods,
  LoadingService,
  StaticPageContentService,
  IStaticPageContentMethods,
  AddGroupService,
  IAddGroupMethods,
  IFormatOverviewDetailMethods,
  FormatOverviewDetailService,
  IUpdateTraceStepMethods,
  UpdateTraceStepService,
} from './components';

export type SuppChainTempOverViewPageAgent = IStaticPageContentMethods &
  IHeaderMethods &
  ISettingsMethods &
  IAppCardListMethods &
  IAddGroupMethods &
  ILoadingMethods &
  IFormatOverviewDetailMethods &
  IUpdateTraceStepMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new AppCardListService(),
    new LoadingService(),
    new AddGroupService(),
    new FormatOverviewDetailService(),
    new UpdateTraceStepService(),
  ];
};

export const getAgent = () => {
  return createAgent<SuppChainTempOverViewPageAgent>({
    plugins: getPlugins(),
  });
};
